module.exports = __webpack_public_path__ + "static/media/venti.da5538ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StandAlone/venti.svg
// module id = 330
// module chunks = 0